var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.download}},[_vm._v(" CSVとしてダウンロード ")])}
var staticRenderFns = []

export { render, staticRenderFns }